import { createZone } from "../../../../scripts/zone";
import { hierarchyTypeValues } from "./zoneTypes";

const addNewZone = async (zoneProps, zones, processors, customerId) => {
    try {
        const processor = processors.find(processor => processor.processorId === zoneProps.processorId);
        const hubId = processor.hubId;
        const newZone = {
            ...zoneProps,
            customerId,
            hubId,
            orderIndex: zones.length ? Math.max(...zones.map(zone => zone.orderIndex)) + 1 : 1
        }
        await createZone(newZone);
    } catch (err) {
        console.log('Failed to add new zone', err);
    }
}

const addMasterVolumeZone = async (processor, customerId, allProcessors=[], isMusicPlayer=false) => {

    try {
        const newZone = {
            zoneName: processor.name + ' Volume',
            processorId: processor.processorId,
            hubId: processor.hubId,
            hierarchyType: allProcessors.length ? hierarchyTypeValues.MASTER : hierarchyTypeValues.NONE,
            customerId,
            orderIndex: 1,
            isMusicPlayer: isMusicPlayer ? 1 : 0
        }
        await createZone(newZone);
    } catch (err) {
        console.log('Failed to add master volume zone', err);
    }
}

export {
    addNewZone,
    addMasterVolumeZone
}